// extracted by mini-css-extract-plugin
export default {"placeholderContainer":"Dropdown_placeholderContainer__1lvrI"};